import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCompany from 'app/store/general/reducers/company.reducer';
import * as fromUsers from 'app/store/general/reducers/users.reducer';
import * as fromCountries from 'app/store/general/reducers/countries.reducer';
import * as fromSidebarSettings from 'app/store/general/reducers/sidebar-settings.reducer';

export interface GeneralState {
  company: fromCompany.State;
  users: fromUsers.State;
  countries: fromCountries.State;
  sidebarSettings: fromSidebarSettings.State;
}

export const generalReducers = {
  company: fromCompany.reducer,
  users: fromUsers.reducer,
  countries: fromCountries.reducer,
  sidebarSettings: fromSidebarSettings.reducer,
};

export const getRootAppState = createFeatureSelector<GeneralState>('general');

// Companies
export const getCompanyState = createSelector(
  getRootAppState,
  (state) => state.company
);

export const getIsDistanceRequired = createSelector(
  getCompanyState,
  (state) => state.requireKmForClosingDeliveryOnCoordinatorApp
);

export const getAreCompanySettingsReady = createSelector(
  getCompanyState,
  (state) => state.areCompanySettingsReady
);

export const getDateFormat = createSelector(
  getCompanyState,
  (state) => state.dateFormat
);

export const getIsWeekStartsAtMonday = createSelector(
  getCompanyState,
  (state) => state.weekStartDayMonday
);

export const getIsTime24HourClock = createSelector(
  getCompanyState,
  (state) => state.time24HourClock
);

export const getTimeZone = createSelector(
  getCompanyState,
  (state) => state.timeZoneId
);

export const getIsProjectInfoHidden = createSelector(
  getCompanyState,
  (state) => state.hideProjectDataOnTM
);

// Users
export const getUsersState = createSelector(
  getRootAppState,
  (state) => state.users
);

export const getUsers = createSelector(getUsersState, (state) => state.users);

export const getIsUsersReady = createSelector(
  getUsersState,
  (state) => state.isReady
);

// Countries
export const getCountriesState = createSelector(
  getRootAppState,
  (state) => state.countries
);

export const getCountries = createSelector(
  getCountriesState,
  (state) => state.countries
);

// Sidebar Settings
export const getSidebarSettingsState = createSelector(
  getRootAppState,
  (state) => state.sidebarSettings
);

export const getSidebarSettings = createSelector(
  getSidebarSettingsState,
  (state) => state.sidebarSettings
);
